import { PropsWithChildren } from "react";

import { Provider as CentrifugeProvider } from "@/components/Centrifuge";

const MessagingProvider = (props: PropsWithChildren) => <CentrifugeProvider {...props} />;

export { MessagingProvider };
